"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromocodeIndiSubtype = exports.PromocodeType = exports.EIndiPromoProduct = exports.processorPromoSubscriptionsProducts = exports.EPromoAppType = exports.EPromoSubtype = void 0;
var EPromoSubtype;
(function (EPromoSubtype) {
    EPromoSubtype["SUBSCRIPTION"] = "subscription";
})(EPromoSubtype = exports.EPromoSubtype || (exports.EPromoSubtype = {}));
var EPromoAppType;
(function (EPromoAppType) {
    EPromoAppType["PROCESSOR"] = "processor";
    EPromoAppType["DAWN"] = "dawn";
    EPromoAppType["WIDGETS"] = "widgets";
    EPromoAppType["INDI"] = "indi";
})(EPromoAppType = exports.EPromoAppType || (exports.EPromoAppType = {}));
exports.processorPromoSubscriptionsProducts = {
    Base: 2,
    Extended: 3,
    Professional: 4,
};
var EIndiPromoProduct;
(function (EIndiPromoProduct) {
    EIndiPromoProduct["SYNASTRY"] = "SYNASTRY";
    EIndiPromoProduct["EMOTIONS"] = "EMOTIONS";
    EIndiPromoProduct["SOLAR"] = "SOLAR";
    EIndiPromoProduct["SESSION"] = "SESSION";
    EIndiPromoProduct["INDI_SUBSCRIPTION"] = "INDI_SUBSCRIPTION";
})(EIndiPromoProduct = exports.EIndiPromoProduct || (exports.EIndiPromoProduct = {}));
var PromocodeType;
(function (PromocodeType) {
    PromocodeType["subscription"] = "subscription";
    PromocodeType["counter"] = "counter";
    PromocodeType["discount"] = "discount";
    PromocodeType["formations"] = "formations";
    PromocodeType["widget"] = "widget";
    PromocodeType["indi"] = "indi";
})(PromocodeType = exports.PromocodeType || (exports.PromocodeType = {}));
var PromocodeIndiSubtype;
(function (PromocodeIndiSubtype) {
    PromocodeIndiSubtype["free"] = "free";
    PromocodeIndiSubtype["discount"] = "discount";
})(PromocodeIndiSubtype = exports.PromocodeIndiSubtype || (exports.PromocodeIndiSubtype = {}));
